import script from "./Get-Started-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Get-Started-Main.vue?vue&type=script&setup=true&lang=js"

import "./Get-Started-Main.vue?vue&type=style&index=0&id=55134bbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55134bbc"]])

export default __exports__